export const config = {
    Accept: 'application/json',
    headers: {
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',   
    },
  };